import { CssBaseline, IconButton, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Home } from 'react-feather';
import { useSelector } from 'react-redux';
import { NavLink, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import favIcon from '../assets/images/favicon.png';
import GlobalStyle from '../component/GlobalStyle';
import { getUserData } from '../redux/slices/users/usersSlice';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
`;

// Dark bar matching the sidebar header, where the inverse (white) logo is legible.
const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(2)};
  padding: ${(props) => props.theme.spacing(2, 4)};
  background-color: ${(props) => props.theme.sidebar.header.background};
  color: ${(props) => props.theme.sidebar.header.color};
`;

const BrandLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(2)};
  text-decoration: none;
  color: inherit;
`;

const BrandIcon = styled.img`
  height: 24px;
  width: auto;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing(4)};
`;

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing(2)};
  padding: ${(props) => props.theme.spacing(2, 4)};
  background: ${(props) => props.theme.footer.background};
  color: ${(props) => props.theme.footer.color};
`;

const FieldService = (): ReactElement => {
  const user = useSelector(getUserData);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Header>
        <IconButton component={NavLink} to="/field-service" edge="start" aria-label="Field service home" sx={{ color: 'inherit' }}>
          <Home size={20} />
        </IconButton>
        <BrandLink to="/field-service">
          <BrandIcon src={favIcon} alt="The Tag System" />
          <Typography variant="h6" component="span">
            TheTagSystem
          </Typography>
        </BrandLink>
      </Header>
      <Main>
        <Outlet />
      </Main>
      <Footer>
        <Typography variant="body2">{user ? `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() : ''}</Typography>
        <Typography variant="body2">{user?.organization?.name ? `for ${user.organization.name}` : ''}</Typography>
      </Footer>
    </Root>
  );
};

export default FieldService;
